var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('router-view')],1),_c('v-footer',{attrs:{"padless":"","app":"","bottom":"","fixed":"","color":"#fffa9f"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" © 2022 Teaching and learning innovation center, Chiangmai university ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }